<div class="d-grid">
    <input type="checkbox" class="btn-check" name="agreement3" id="3" autocomplete="off" #agreement3 [ngModel]>
    <label class="btn btn-secondary" [class.btn-yes-active]="agreement3.checked"
        [class.btn-wht]="!agreement3.checked">
        {{'btnAgree' | propValue | uppercase }}
    </label>
</div>